import userSessionStorage from "./userSessionStorage"

export const calculateAge = () => {
  const userSession =  new userSessionStorage()
  const userInfo = userSession.getUserInfo()
  
  if (!userInfo) return false 
  
  const today = new Date()
  const birthDate = new Date(userInfo.birthdate)
  
  let age = today.getFullYear() - birthDate.getFullYear()

  const m = today.getMonth() - birthDate.getMonth()
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--
  }

  return age
}

export const getAgeSegment = age => {
  if (age >= 9 && age <= 17) {
    return "Adolescente"
  } else if (age >= 18 && age <= 24) {
    return "Adulto Joven"
  } else if (age >= 25) {
    return "Adulto"
  } else {
    return "Anónimo"
  }
}
